export class DatePicker {
  constructor(difference) {
    this.styleId = 1
    this.startDateFlag = ''
    this.endDateFlag = ''
    this.width = 200
    this.height = 40
    this.top = 20
    this.left = 20
    this.innerElement = "cxDatePicker"
    this.value = "2023-05-05"
    this.dates="2023-05-05"
    this.startDate=''
    this.endDate = ''
    this.dateType = 'date'  // year/month/date/dates/months/years week/datetime/datetimerange/ daterange/monthrange
    this.dateFormat = 'yyyy-MM-dd'
    this.showShortcuts = false
    // this.shortcuts = '今天'
    this.dataPickerType = 1 // 1是取具体的某天、某年、某周等   2是多选  3是指某个范围
    this.fontFamily = "sans-serif"
    this.fontSize = 14
    this.fontColor = 'rgba(255,255,255,0.6)'
    this.fontWeight = 600
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.borderColor = "#3D82F2"
    this.borderWidth = 1
    this.borderStyle = "solid" // solid, dashed, dotted
    this.borderIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.background=[
      {
        type: 'color',
        isThemeColor : false,
        color: '#091333',
        label: "颜色"
      }
    ]

    this.selectBorderColor = "#091333"
    this.selectBorderWidth = 1
    this.selectBorderStyle = "solid" // solid, dashed, dotted
    this.selectBorderIsThemeColor = false
    this.selectBoxShadowColor = []
    this.selectBoxShadowH = []
    this.selectBoxShadowV = []
    this.selectBoxShadowBlur = []
    this.selectBoxShadowSpread = []
    this.selectFontSize = 14
    this.selectFontFamily= 'sans-serif'
    this.selectFontWeight = "400"
    this.selectFontColor = "rgba(255,255,255,1)"

    this.notCurrentTextIsThemeColor = false
    this.notCurrentTextColor='#333'

    this.datePaddingTopVal=4
    this.datePaddingBottomVal=4

    this.selectBgColor = "rgba(0, 0, 0, 0.8)"
    this.selectBackground=[{
      type: 'color',
      isThemeColor : false,
      color: '#091333',
      label: "颜色"
    }]

    this.activeFontSize = 14
    this.activeFontFamily= 'sans-serif'
    this.activeFontWeight = "400"
    this.activeFontColor = "rgba(255,255,255,1)"
    this.activeBorderRadius = 0
    this.activeBorderTopLeftRadius = 0
    this.activeBorderTopRightRadius = 0
    this.activeBorderBottomLeftRadius = 0
    this.activeBorderBottomRightRadius = 0
    this.activeBorderTypeFlag=2
    this.activeBgColor= "rgba(0,0,0,0)"
    this.activeBgColorIsThemeColor = false
    this.activeBorderColor = "#333"
    this.showActiveBorder = false
    this.activeBorderIsThemeColor = false

    this.hoverFontSize = 14
    this.hoverFontFamily= 'sans-serif'
    this.hoverFontWeight = "400"
    this.hoverFontColor = "rgba(255,255,255,1)"
    this.hoverBorderRadius = 0
    this.hoverBorderTopLeftRadius = 0
    this.hoverBorderTopRightRadius = 0
    this.hoverBorderBottomLeftRadius = 0
    this.hoverBorderBottomRightRadius = 0
    this.hoverBorderTypeFlag=2
    this.hoverBgColor= "rgba(0,0,0,0)"
    this.hoverBgColorIsThemeColor = false
    this.hoverBorderColor = "#333"
    this.showHoverBorder = false
    this.hoverBorderIsThemeColor = false

    //标题样式
    this.titleFontFamily = "sans-serif"
    this.titleFontSize = 20
    this.titleFontWeight = 400
    this.titleFontStyle = "normal"
    this.titleTextDecoration = "none"
    this.titleLineHeight = 40
    this.titleLineHeightType = "px"
    this.titleLetterSpacing = 0
    this.titleWritingMode = "horizontal-tb"
    this.titleTextAlign = "center"
    this.titleTextIsThemeColor = false
    this.titleColor = "rgb(255,255,255)"
    this.titleBgColorIsThemeColor = true
    this.titleBgColor = "rgb(255, 255, 255)"
    this.titlePaddingTypeFlag = 1
    this.titlePadding = 0
    this.titlePaddingTop = 0
    this.titlePaddingRight = 0
    this.titlePaddingBottom = 0
    this.titlePaddingLeft = 0
    // 分割线样式
    this.lineColor='#fff'
    this.lineColorIsThemeColor = false

    // 按钮样式
    this.primaryBtnFontSize = 14
    this.primaryBtnFontFamily= 'sans-serif'
    this.primaryBtnFontWeight = "400"
    this.primaryBtnFontColor = "rgba(255,255,255,1)"
    this.primaryBtnBgColor ='#3D82F2'
    this.primaryBtnBgColorIsThemeColor =true
    this.primaryBtnBorderColor = "#3D82F2"
    this.primaryBtnBorderWidth = 1
    this.primaryBtnBorderStyle = "solid" // solid, dashed, dotted
    this.primaryBtnBorderIsThemeColor = true

    this.cancleBtnFontSize = 14
    this.cancleBtnFontFamily= 'sans-serif'
    this.cancleBtnFontWeight = "400"
    this.cancleBtnFontColor = "#3D82F2"
    this.cancleBtnBgColor ='rgba(0,0,0,0)'
    this.cancleBtnBgColorIsThemeColor =false
    this.cancleBtnBorderColor = "#3D82F2"
    this.cancleBtnBorderWidth = 1
    this.cancleBtnBorderStyle = "solid" // solid, dashed, dotted
    this.cancleBtnBorderIsThemeColor = true
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
